<script lang="ts">
  import { formatFrom24To12Hours } from './helpers/date-helper';
  const DAYS = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  type Availability = {
    alwaysOpen: boolean;
    days: {
      enabled: boolean;
      start: string;
      end: string;
    }[];
  };

  export let availability: Availability = {
    alwaysOpen: false,
    days: [],
  };

  function formatHours(hour) {
    return formatFrom24To12Hours(hour)
      .toLocaleLowerCase()
      .replace(' ', '')
      .replace(':00', '')
      .replace('12am', '0am')
      .replace('12:30am', '0:30am');
  }

  $: dates = groupDates(availability.days);

  function groupDates(days) {
    const groups = [];
    groups.push({ dayStart: DAYS[0], dayEnd: DAYS[0], ...days[0] });

    for (let i = 1; i < days.length; i++) {
      const groupsLength = groups.length - 1;
      if (
        groups[groupsLength].enabled === days[i].enabled &&
        groups[groupsLength].start === days[i].start &&
        groups[groupsLength].end === days[i].end
      ) {
        groups[groupsLength].dayEnd = DAYS[i];
      } else {
        groups.push({
          dayStart: DAYS[i],
          dayEnd: DAYS[i],
          ...days[i],
        });
      }
    }
    return groups;
  }

  function formatDay(date) {
    if (date.dayEnd && date.dayEnd !== date.dayStart) {
      return `${date.dayStart} - ${date.dayEnd}`;
    }
    return date.dayStart;
  }
</script>

{#if availability.alwaysOpen}
  <div class="open-24/7">We're open 24 hours per day 7 days a week</div>
{:else}
  <div class="days">
    {#each dates as date, index (index)}
      <div class="day">
        <span>{formatDay(date)}:</span>
        <span class="hours">
          {#if date.enabled}
            <span>{formatHours(date.start)} - {formatHours(date.end)}</span>
          {:else}
            Closed
          {/if}
        </span>
      </div>
    {/each}
  </div>
{/if}

<style>
  :root {
    --spacing-large-md: 36px;
    --spacing-micro: 12px; /*between Monday, Tuesday, etc..*/
    --availability-margin-top: 20px;
  }
  .days {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    flex-direction: column;
    gap: var(--spacing-micro, 12px);
    margin: var(--availability-margin-top) 0 0 0;
  }

  .day {
    align-items: flex-start;
    align-self: stretch;
    display: flex;
    gap: var(--spacing-quarck, 2px);
  }

  .days span:first-child {
    min-width: var(--spacing-large-md);
  }
  .days span:last-child {
    flex: 1 0 0;
  }
  .day {
    color: var(--vlt-lp-background-text, #202123);
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 21px */
    letter-spacing: 0.14px;
    padding: 0;
    margin: 0;
    width: 150px;
  }

  .open-24\/7 {
    color: var(--vlt-lp-background-text, #202123);
    margin: var(--availability-margin-top) 0 0 0;
  }

  @media screen and (min-width: 768px) and (max-width: 1023px) {
    .days {
      grid-template-columns: 80px 115px;
    }
  }
</style>
